import FaiBox from "MuiComponents/FaiBox";
import {
	Box,
	Button,
	Card,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	TextField,
	Typography,
} from "@mui/material";
import BackIcon from "components/AppIcons/BackIcon";
import DynamicCardContent from "screens/OrdersAndReturns/Returns/components/DynamicCardContent";
import Axios from "services/api/config";
import { useState } from "react";
import { toast } from "sonner";
import { updateMerchantStatus } from "services/api/routes/Admin";

export default function MerchantDetail({ merchant, setMerchant }) {
	const [openRejectModal, setOpenRejectModal] = useState(false);
	const [rejectComment, setRejectComment] = useState("");
	const [isApproving, setApproving] = useState(false);
	const [isRejecting, setRejecting] = useState(false);

	const {
		businessInformation = {},
		brandDetails = {},
		bankDetails = {},
		contactInformation = {},
		logisticsInformation = {},
		...details
	} = merchant.row || {};

	const businessDetails = {
		title: "Business Details",
		data: [
			{ label: "Company Name", value: businessInformation?.companyName || "-" },
			{ label: "Email", value: businessInformation?.companyEmail || "-" },
			{
				label: "Office Address",
				value: businessInformation?.companyAddress || "-",
			},
			{ label: "Document", value: businessInformation?.document || "-" },
			{ label: "GST No.", value: businessInformation?.gstNumber || "-" },
		],
	};

	const brandData = {
		title: "Brand Details",
		data: [
			{
				label: "Brand Name",
				value: brandDetails?.brands?.[0]?.brandName || "-",
			},
			{ label: "Website", value: brandDetails?.brands?.[0]?.website || "-" },
			{
				label: "Brand Description",
				value: brandDetails?.brands?.[0]?.brandDescription || "-",
			},
			{
				label: "Categories",
				value: brandDetails?.brands?.[0]?.categories || "-",
			},
			{
				label: "Selling on other platform",
				value: brandDetails?.brands?.[0]?.sellingOnOtherPlatform || "-",
			},
		],
	};

	const bankData = {
		title: "Bank Details",
		data: [
			{ label: "Account Holder", value: bankDetails?.accountHolderName || "-" },
			{ label: "Account Number", value: bankDetails?.bankAccountNumber || "-" },
			{ label: "Account Type", value: bankDetails?.accountType || "-" },
			{ label: "Bank Name", value: bankDetails?.bankName || "-" },
			{ label: "IFSC Code", value: bankDetails?.ifscCode || "-" },
		],
	};

	const logisticData = {
		title: "Logistics Information",
		// lat: 19.076
		// lng: 72.8777
		data: [
			{ label: "Address", value: logisticsInformation?.address || "-" },
			{ label: "City", value: logisticsInformation?.city || "-" },
			{ label: "State", value: logisticsInformation?.state || "-" },
			{ label: "Country", value: logisticsInformation?.country || "-" },
			{ label: "Phone", value: logisticsInformation?.phone || "-" },
			{
				label: "Pickup Location",
				value: logisticsInformation?.pickupLocationNickName || "-",
			},
			{ label: "Pin code", value: logisticsInformation?.pinCode || "-" },
			{
				label: "Shipper Name",
				value: logisticsInformation?.shipperName || "-",
			},
		],
	};

	const updateMerchantData = async (
		status: string,
		rejectionReason: string
	) => {
		try {
			await Axios({
				...updateMerchantStatus,
				data: {
					merchantId: details.id,
					status: status,
					rejectionReason: status === "REJECTED" ? rejectionReason : undefined,
				},
			});
		} catch (error) {
			console.error("Error updating merchant data:", error);
		}
	};

	const handleReject = async () => {
		try {
			setRejecting(true);
			await updateMerchantData("REJECTED", rejectComment);

			toast.success("Merchant rejected successfully");
			setOpenRejectModal(false);
			setMerchant(null); // Close merchant details
		} catch (error) {
			console.error("Error rejecting merchant:", error);
		} finally {
			setRejecting(false);
		}
	};

	const handleApprove = async () => {
		try {
			setApproving(true);
			await updateMerchantData("APPROVED", "");

			toast.success("Merchant approved successfully");
			setOpenRejectModal(false);
			setMerchant(null); // Close merchant details
		} catch (error) {
			console.error("Error approving merchant:", error);
		} finally {
			setApproving(false);
		}
	};

	console.log(merchant);

	return (
		<div className="space-y-2">
			<Card className="my-6 p-3 md:p-6 space-y-4">
				<Box className="flex justify-between">
					<Button
						startIcon={<BackIcon />}
						onClick={() => setMerchant()}
						className="!p-1 text-theme"
					>
						Back to Merchant Onboarding
					</Button>
				</Box>
				<Box>
					<Box className="mt-4">
						<div className="flex justify-between items-center mb-4">
							<p>Merchant ID # {merchant.id}</p>
							<Button className="bg-black !text-white" variant="contained">
								Download Details
							</Button>
						</div>
					</Box>
					<Box
						className="rounded-lg p-4 space-y-4"
						sx={{ backgroundColor: "#F9E9DA" }}
					>
						<Grid
							xs={12}
							className="rounded-lg flex gap-4 justify-between bg-white p-4"
						>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Merchant Name
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									{`${contactInformation?.firstName || ""} ${
										contactInformation?.lastName || ""
									}`}
								</Typography>
							</FaiBox>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Email
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									{contactInformation?.email || "-"}
								</Typography>
							</FaiBox>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Contact No.
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									{contactInformation?.primaryContactNo || "-"}
								</Typography>
							</FaiBox>
							<FaiBox className="">
								<Typography
									variant="h6"
									className="!text-sm !font-medium !text-gray-400"
								>
									Designation
								</Typography>
								<Typography variant="body2" className="!text-base !font-medium">
									{contactInformation?.designation || "-"}
								</Typography>
							</FaiBox>
						</Grid>
						<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
							<DynamicCardContent {...businessDetails} />
							<DynamicCardContent {...brandData} />
							<DynamicCardContent {...bankData} />
						</div>
						<DynamicCardContent {...logisticData} startSize={3} endSize={9} />
					</Box>
					{details.accountStatus === "APPROVED" ? (
						<div className="flex justify-end mt-4"><span className="rounded bg-green-100 px-4 py-2 font-semibold text-green-700">Merchant approved</span></div>
					) : details.accountStatus === "REJECTED" ? (
						<div className="flex justify-end mt-4"><span className="rounded bg-red-100 px-4 py-2 font-semibold text-red-700">Merchant rejected</span></div>
					) : (
					<div className="flex justify-end gap-4 mt-4">
						<Button
							variant="contained"
							className="!bg-red-500 !text-white"
							onClick={() => setOpenRejectModal(true)}
							disabled={isRejecting}
						>
							{isRejecting ? "Rejecting..." : "Reject"}
						</Button>
						<Button
							variant="contained"
							className="!bg-green-500 !text-white"
							onClick={handleApprove}
							disabled={isApproving}
						>
							{isApproving ? "Approving..." : "Approve"}
						</Button>
					</div>
					)}
				</Box>
			</Card>
			{/* Reject Merchant Modal */}
			<Dialog
				open={openRejectModal}
				onClose={() => setOpenRejectModal(false)}
				maxWidth="sm"
				fullWidth
			>
				<DialogTitle className="text-center">Reject Merchant</DialogTitle>
				<DialogContent className="space-y-4">
					<Typography className="text-center text-black">
						Are you sure to reject merchant onboarding?
					</Typography>
					<TextField
						fullWidth
						multiline
						rows={4}
						placeholder="Write comment"
						value={rejectComment}
						onChange={(e) => setRejectComment(e.target.value)}
						className="mt-4"
					/>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => setOpenRejectModal(false)}
						variant="text"
						className="!text-black"
					>
						Cancel
					</Button>
					<Button
						onClick={handleReject}
						variant="contained"
						className="!bg-red-500 !text-white"
					>
						Reject
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
